import { makeStyles } from "@mui/styles";
import { DataGrid, GridFeatureMode } from "@mui/x-data-grid";

interface IDataGrid {
  columns: Array<any>;
  rows: any;
  rowCount: number;
  pageSize: number;
  setPageSize: any;
  setPage: any;
  onSortChange: any;
  getRowId?: any;
  paginationMode?: GridFeatureMode;
  conditionalRowStyles?:any;
}
const useStyles = makeStyles({
  root: {
    "& .MuiDataGrid-root": {

    },
    "& .MuiDataGrid-footerContainer": {
      justifyContent: "right",
    },

    "& .MuiPagination-ul .MuiButtonBase-root": {
      borderRadius: 5,
      border: "1px solid gray",
    },

    "& .MuiButtonBase-root.MuiPaginationItem-root.Mui-selected": {
      backgroundColor: "#262647",
    },

    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 600,
    },

    "& .MuiDataGrid-cellContent": {
      
    },

    "& .MuiDataGrid-columnHeader:focus-within": {
      // remove border when hover or selected grid columns
      outline: "solid #cdcdcd 0px !important",
    },

    "& .MuiDataGrid-columnHeader:focus": {
      outline: "solid #cdcdcd 0px !important",
    },

    "& .MuiDataGrid-columnHeaderTitleContainer": {
      // make Sorting icon right
      width: "100%",
      justifyContent: "space-between",
      paddingRight: "0px",
    },
    "& .MuiDataGrid-columnHeaderTitleContainer:hover": {
      // Added for sorting icon moving left and right.
      width: "100%",
      justifyContent: "space-between",
      paddingRight: "0px !important",
    },
    "& .MuiDataGrid-columnHeader": {
      //width: "100%",
      // backgroundColor: "#3E62A4",
      backgroundColor:"#03025d",
      color: "white",
      border: 0,
      marginBottom: '2px',
    },
    "& .MuiDataGrid-iconButtonContainer": {
      marginLeft: "0px",
      visibility: "visible !important",
      width: "auto !important",
    },
    "& .MuiButtonBase-root.MuiIconButton-root:hover": {
      backgroundColor: "#ffffff",

    },
    '&.MuiDataGrid-root .MuiDataGrid-row': {
      borderRadius: '2px',
      marginTop: '3px',
    }, '& .MuiDataGrid-virtualScrollerContent': {
      boxSizing: 'content-box'
    },
   
  },
});
const DataGridComponent = (props: IDataGrid) => {
  const {
    columns,
    rows,
    getRowId
  } = props;
  const classes = useStyles();

  return (

    <DataGrid
      rows={rows}
      rowHeight={60}
      columns={columns}
      pageSize={5}
      rowsPerPageOptions={[5]}
      getRowId={getRowId}
      className={classes.root}
      // // Styling...
      // showColumnRightBorder={true}
       //showCellRightBorder={true}
       //autoHeight={true}
      sx={{
        boxShadow: 2,
        border: 0,
        "& .MuiDataGrid-cell:hover": {
          // color: palette.primary.main,
        },

        margin: "3% 3% 0% 3%",
        marginTop: 0
      }}
      // hideFooter={true}
      disableColumnMenu={true}
      hideFooterSelectedRowCount
      hideFooter
    />
  );
};

export default DataGridComponent;
